"use strict";
/**
 * Dictation Services Export
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.dictationProcessingService = exports.DictationProcessingService = void 0;
var dictationProcessingService_1 = require("./dictationProcessingService");
Object.defineProperty(exports, "DictationProcessingService", { enumerable: true, get: function () { return dictationProcessingService_1.DictationProcessingService; } });
Object.defineProperty(exports, "dictationProcessingService", { enumerable: true, get: function () { return dictationProcessingService_1.dictationProcessingService; } });
//# sourceMappingURL=index.js.map